<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Yetkinlik</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name"> 
            <input type="text" v-model="value.Name" class="form-control" placeholder="Yetkinlik"/>
            </v-validator> 
        </div>
    </div>
</template>

<script>
import VValidator from '@/components/VValidator.vue'
export default {
    props:{
        value:Object,
        errors:Object
    }
}
</script>

<style>

</style>